module.exports = __webpack_public_path__ + "img/hq_qrcode.cc532980.jpg";